import { inject, Injectable } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { CustomerModel } from '@df/session/api/customer.model';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NNewsletterModal } from './cms-newsletter-modal.component';

@Injectable({
    providedIn: 'root'
})
export class NewsletterModalModalInitiatorService extends AbstractDfModalInitiatorService {
    private readonly customerModel = inject(CustomerModel);
    private readonly iCmsBlockResource = inject(ICmsBlockResource);
    private readonly timeoutService = inject(TimeoutService);

    async listen(cb: () => void): Promise<void> {
        await this.customerModel.load();
        if (!this.customerModel.data.subscribed) {
            const block = (await this.iCmsBlockResource.retrieve(
                { bareUrl: NNewsletterModal.blockId },
                undefined
            )) as NNewsletterModal.Block;
            if (block?.data && !block.data.content?.styles?.hidden) {
                const delay = block.data?.content?.delay;
                if (delay) {
                    this.timeoutService.setTimeout(() => cb(), delay * 1000);
                } else {
                    cb();
                }
            }
        }
    }
}
